import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { fetch_tab } from './api';
import type { TabName } from './types';

export function use_tab(tab: TabName, coords?: { lat: number; lng: number }) {
  return useQuery({
    queryKey: ['app-tab', tab, coords?.lat ?? null, coords?.lng ?? null],
    queryFn: () => fetch_tab(tab, coords),
    placeholderData: keepPreviousData, // no flash when coords arrive after first render
    staleTime: 30 * 1000,
  });
}
